function _(n,o,t){var a="razdwatrzy";o.exports=function(){return"function"==typeof a.contains&&(!0===a.contains("dwa")&&!1===a.contains("foo"))}}
//# sourceMappingURL=is-implemented.min.js.map